<template>
  <div>
    <div class="creator-panel d-flex align-center">
      <Avatar
        class="creator-avatar"
        :size="45"
        :has-border="false"
        :userProfile="user?.userProfile"
      />
      <div class="creator-handle mx-4">
        <div class="pen-name">
          {{
            $t("fullName", {
              firstName: user?.userProfile?.firstName,
              lastName: user?.userProfile?.lastName,
            })
          }}
        </div>
        <div class="username">@{{ user?.userProfile?.username }}</div>
      </div>
      <!-- TODO: Add "more info" button that links to future creator page -->
      <!-- Jira Task: https://story-city.atlassian.net/browse/SC-673 -->
    </div>
  </div>
</template>

<script>
import { gql } from "graphql-tag";
import Avatar from "@/components/User/Avatar.vue";

export default {
  name: "Creator",
  components: {
    Avatar,
  },
  props: {
    creatorId: {
      type: String,
      required: true,
    },
    showMoreInfo: {
      type: Boolean,
      default: false,
    },
  },
  apollo: {
    user: {
      query: gql`
        query User($id: ID!) {
          user(id: $id) {
            id
            isVerified
            userProfile {
              id
              username
              penName
              firstName
              lastName
              image {
                id
                contentUrl
              }
            }
          }
        }
      `,
      variables() {
        return {
          id: this.creatorId,
        };
      },
      skip() {
        return !this.creatorId;
      },
    },
  },
};
</script>

<style scoped lang="scss">
.pen-name {
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: var(--v-secondaryText-base);
}

.username {
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  color: var(--v-demphasizedText-base);
}
</style>
